import { Checkbox } from '@design-system';
import { useTranslation } from 'next-i18next';

export interface ApplyToAllCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const ApplyToAllCheckbox = ({
  checked,
  onChange,
}: ApplyToAllCheckboxProps) => {
  const { t } = useTranslation('checkout');

  return (
    <Checkbox
      checked={checked}
      id="framing-apply-to-all"
      label={t('framing.applyToAll')}
      name="framing-apply-to-all"
      onChange={(event) => onChange(event.target.checked)}
      type="checkbox"
      value="apply-to-all"
    />
  );
};
